import { DEFAULT_DISPLAY_CURRENCY } from "../constants/currency";
import { normalizeCurrency } from "./currency";
import { supabase } from "./supabaseClient";

export const isMissingCurrencyPreferenceError = (error) =>
  error?.code === "42P01" ||
  error?.code === "PGRST205" ||
  /user_currency_preferences/i.test(error?.message || "");

export const fetchCurrencyPreference = async (userId) => {
  const result = await supabase
    .from("user_currency_preferences")
    .select("display_currency,has_user_chosen_currency")
    .eq("user_id", userId)
    .maybeSingle();

  if (isMissingCurrencyPreferenceError(result.error)) {
    return { data: null, error: null };
  }

  return result;
};

export const saveCurrencyPreferenceToSupabase = async (
  userId,
  displayCurrency
) => {
  const result = await supabase.from("user_currency_preferences").upsert(
    {
      user_id: userId,
      display_currency: normalizeCurrency(
        displayCurrency,
        DEFAULT_DISPLAY_CURRENCY
      ),
      has_user_chosen_currency: true,
      updated_at: new Date().toISOString(),
    },
    { onConflict: "user_id" }
  );

  if (isMissingCurrencyPreferenceError(result.error)) return;
  if (result.error) throw result.error;
};

